import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { SelectionPreview, isoDate } from './SelectionPreview';
import { isOver, matchesQuery } from './selectionKind';
import { SEL_API, shareSelection } from '../../lib/selectionShare';
import { ShareNudge } from '../ShareNudge';

export const started = (s, st) => {
  if (st?.some((x) => x.elapsed != null || (x.status && x.status !== 'NS' && x.status !== 'TBD'))) return true;
  return (s.picks || []).some((p) => p.match_date && p.match_time && new Date(`${isoDate(p.match_date)}T${p.match_time}:00`) <= new Date());
};

const EMPTY = {
  live: 'Nessuna selezione in corso. Tocca + per aggiungerne una',
  scheduled: 'Nessuna selezione programmata. Tocca + per aggiungerne una',
};

// Diario "In corso" / "Programmate": collapsed previews with the live trend
export const SavedSelectionsView = ({ tab, query = '', reloadKey, onEdit, nudgeId }) => {
  const [list, setList] = useState(null);
  const [states, setStates] = useState({});
  const load = useCallback(() => axios.get(SEL_API).then((r) => setList(r.data)).catch(() => setList([])), []);
  useEffect(() => { load(); }, [load, reloadKey]);

  const count = list?.length || 0;
  useEffect(() => {
    if (!count) return undefined;
    const tick = () => axios.get(`${SEL_API}/live`, { timeout: 20000 }).then((r) => {
      const data = r.data || {};
      setStates(data);
      // finished or lost selections move to Concluse
      setList((cur) => (cur || []).filter((s) => !isOver(s, data[s.selection_id])));
    }).catch(() => {});
    tick();
    const t = setInterval(tick, 60000);
    return () => clearInterval(t);
  }, [count]);

  const remove = useCallback(async (sel) => {
    if (!window.confirm('Eliminare questa selezione?')) return;
    await axios.delete(`${SEL_API}/${sel.selection_id}`).catch(() => toast.error('Eliminazione non riuscita'));
    setList((cur) => cur.filter((s) => s.selection_id !== sel.selection_id));
  }, []);

  const shown = (list || []).filter((s) => (tab === 'live') === started(s, states[s.selection_id]) && matchesQuery(s, query));
  return (
    <div data-testid={`saved-selections-${tab}`}>
      {list === null && <Loader2 className="w-6 h-6 animate-spin text-[#F5A623] mx-auto" />}
      {list && shown.length === 0 && (
        <p className="text-center text-gray-500 text-sm py-10" data-testid="saved-selections-empty">{query.trim() ? 'Nessuna selezione trovata.' : EMPTY[tab]}</p>
      )}
      <div className="space-y-3">
        {shown.map((s) => (
          <React.Fragment key={s.selection_id}>
            <SelectionPreview sel={s} states={states[s.selection_id]} onShare={shareSelection} onDelete={remove} onEdit={onEdit} />
            {s.selection_id === nudgeId && <ShareNudge />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SavedSelectionsView;
